import React from "react";
import { CheckboxGroupProps } from "react-aria-components";

import { _CheckboxGroup } from "./assets/_CheckboxGroup";
import { _Text } from "../../../_assets/_Text";
import {
  FieldErrors,
  FieldErrorsProps,
} from "../../_assets/input-wrapper/FieldErrors";
import { FormLabelRAC } from "../../_assets/input-wrapper/FormLabelRAC";

export interface CheckboxGroupPropsRAC
  extends Omit<CheckboxGroupProps, "children"> {
  children?: React.ReactNode;
  label?: string;
  info?: string;
  description?: string;
  errors?: FieldErrorsProps["children"];
  isCard?: boolean | undefined;
  testID?: string;
}

interface CheckboxGroupRACContextType {
  isCard?: boolean;
  isGroup: boolean;
}

export const CheckboxGroupRACContext =
  React.createContext<CheckboxGroupRACContextType>({
    isCard: false,
    isGroup: false,
  });

export function CheckboxGroupRAC(props: CheckboxGroupPropsRAC) {
  const { label, info, description, children, ...checkboxGroupProps } = props;

  return (
    <CheckboxGroupRACContext.Provider
      value={{ isCard: props.isCard, isGroup: true }}
    >
      <_CheckboxGroup {...checkboxGroupProps}>
        {props.label && (
          <FormLabelRAC isRequired={props.isRequired} info={props.info}>
            {props.label}
          </FormLabelRAC>
        )}
        {children}
        {description && (
          <_Text slot="description" style="input/helper" color="text-weak">
            {description}
          </_Text>
        )}
        <FieldErrors>{props.errors}</FieldErrors>
      </_CheckboxGroup>
    </CheckboxGroupRACContext.Provider>
  );
}
